export default "__VITE_ASSET__DKf_$zQ9__"